import { Component, EventEmitter, Input, Output, QueryList } from '@angular/core';

import { Group } from '../../../../tool/model/group.model';
import { TableColumnComponent } from '../components/column/table-column.component';
import { ToolSet } from "@app/tool/model/toolSet.model";
import { MenuItem } from "primeng/api";
import { TableInfoRowComponent } from "@components/custom-table/components/info-row/info-row.component";


@Component({
    selector: 'app-table-body',
    templateUrl: 'table-body.component.html',
    styleUrls: ['./table-body.component.scss']
})
export class TableBodyComponent {
    @Input() columns: QueryList<TableColumnComponent>;
    @Input() infoRow: TableInfoRowComponent;
    @Input() hasActiveGroups = false;
    @Input() rowExpand = true;
    @Input() isLoading = false;
    @Input() records = [];
    @Input() filteredByLineId;
    @Input() contextMenuItems: MenuItem[] = [];
    @Input() includeSecondaryLines = false;
    @Input() filterBySecLinesId: number;
    @Input() notMyProblem = false; // TODO follow the trail, and realise that the table shouldn't do this

    @Output() rowClick = new EventEmitter<any>();
    @Output() rowContextMenu = new EventEmitter<any>();
    @Output() rowExpandClick = new EventEmitter<any>();

    onRowClick(record) {
        if (this.rowExpand || record.children) {
            this.toggleRowExpand(record);
        }
        this.rowClick.emit(record);
    }

    onRightClick(event, record) {
        this.rowContextMenu.emit({
            event: event,
            record: record
        });
    }

    toggleRowExpand(item) {
        item.expanded = !item.expanded;
    }

    toggleExpandAll(expanded) {
        this.records.forEach(rec => this.toggleRowExpand(rec));
    }

    isGroup(record) {
        return record instanceof Group;
    }

    isSet(record) {
        return record instanceof ToolSet;
    }

    isDisabled(record) {
        return record.disabled;
    }

    // TODO - move into a tree node interface
    getNrOfParents(record) {
        let nrOfParents = 0;
        let recParent = record.parent;
        while (recParent) {
            nrOfParents++;
            recParent = recParent.parent;
        }
        return nrOfParents;
    }

    getBackgroundColor(record: any, withBackgroundColor: boolean, field: string) {
        if (!withBackgroundColor) {
            return '';
        }
        return record.getBackgroundColor(record[field]);
    }

    // TODO @Bogdan This fucks up OO design so HARD. A table should not know about a tool
    hasPrimaryLineColoring(record) {
        if (this.includeSecondaryLines && this.filterBySecLinesId !== undefined) {
            return record && record.mainLine && record.mainLine.id === this.filterBySecLinesId;
        }
    }

    // TODO @Bogdan This fucks up OO design so HARD. A table should not know about a tool
    hasSecondaryLineColoring(record) {
        return this.includeSecondaryLines && this.filterBySecLinesId !== undefined && record && record.mainLine &&
            this.filterBySecLinesId && record.mainLine.id !== this.filterBySecLinesId;
    }

    computeRecord(record: any) {
        return "";
    }
}
